export const safeParse = (jsonString) => {
  if (typeof jsonString !== 'string') {
    console.error('JSON parse failed, safeParse received wrong type of data');
    return '';
  }

  try {
    return JSON.parse(jsonString);
  } catch (e) {
    console.error('JSON parse failed', e, jsonString);
    return ''
  }
};
